export default __webpack_public_path__ + "static/media/banner-onboarding-task.781c2136.png";